// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1B_tZ","title":"Header_title__2-68r","left":"Header_left__1c5gv","clinicName":"Header_clinicName__1U7SO"};